/**
 * Loss History Detail (#33939) — the ONE module that owns the boundary where a loss-history entry
 * is written and read. Consumed by the staff-fe manual add form + Loss Summary, the IMT importer,
 * the A+/Verisk farm pull, the farm rater, and the policy-mod + offer authz gates.
 */
import { v4 as uuidv4 } from 'uuid';
import { MANUAL_ENTRY_SOURCE } from './constants';
import { normalizeLossDate } from './normalize';
import type { LossHistoryEntry } from './types';

export * from './constants';
export * from './normalize';
export * from './types';
export * from './build';
export * from './merge';
export * from './authz';
export * from './rating';
export * from './claim-free';
export * from './summary';

/** A manual entry is one a user created; auto-pulled entries carry a report source. */
export const isManualEntry = (entry: { source?: string | null } | null | undefined): boolean =>
  entry?.source === MANUAL_ENTRY_SOURCE;

/**
 * Prepare a persisted entry for the staff-fe form: ensure a stable id (FormList React keys) and
 * normalize `lossDate` to ISO so an already-persisted A+ `yyyyMMdd` date renders and counts.
 */
export const hydrateLossEntryForForm = <T extends Partial<LossHistoryEntry>>(
  entry: T
): T & { id: string; lossDate: string | null } => ({
  ...entry,
  id: entry?.id || uuidv4(),
  lossDate: normalizeLossDate(entry?.lossDate)
});
